import { z } from 'zod';

export const organizationLanguageSchema = z.object({
    enabled: z.boolean(),
    isDefault: z.boolean(),
    language: z.string(),
});

export type OrganizationLanguage = z.infer<typeof organizationLanguageSchema>;

export const organizationLanguagesResponseSchema = z.object({
    languages: organizationLanguageSchema.array(),
});

export type OrganizationLanguagesResponse = z.infer<typeof organizationLanguagesResponseSchema>;

export const organizationStatisticsSchema = z.object({
    clustersCount: z.number(),
    familiesCount: z.number(),
    levelsCount: z.number(),
    rolesCount: z.number(),
    skillsCount: z.number(),
});

export type OrganizationStatistics = z.infer<typeof organizationStatisticsSchema>;
